export default __webpack_public_path__ + "static/media/shareicon.06d38a87.svg";